module.exports = __webpack_public_path__ + "static/media/viska-red.ce73c45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/viska-red.png
// module id = 111
// module chunks = 0